module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution2_1@2x-78072ff2ffa454812cf12bb1792d0b6b.png";